import React from "react"
import PropTypes from "prop-types"
import Loader from "./Loader"

class Conversation extends React.Component {
    constructor(props) {
        super(props);
        // move this to this.state because
        // we want to add to it if form is submitted
        this.state = {
            messages: this.props.messages,
            text: ""
        }
    }

    render () {
        return (
            <React.Fragment>
              <form onSubmit={event => {this.add(event)}} className="comment-box">
                <textarea name="text" value={this.state.text} onChange={event => {this.setState({text: event.target.value})}} className="input-text"/>
                <div className="text-right mar-v">
                    <input type="submit" disabled={!this.state.text} value="Send message" className="btn-primary" id="addMessage" />
                </div>
              </form>

              <List messages={this.state.messages} />
            </React.Fragment>
        );
    }

    add (event) {
        event.preventDefault();

        Loader.set(true, "#addMessage");

        fetch(this.props.id, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': this.props.token
            },
            body: JSON.stringify({messages_attributes: [{body: event.target.childNodes[0].value}]})
        })
            .then(response => response.json())
            .then(message => {
                console.log(message);
                this.state.messages = message;
                this.state.text = "";
                this.setState(this.state);
                Loader.set(false, "#addMessage");
            });
    }
}


class List extends React.Component {
    render () {
        return <section className="comments-list">
     {this.props.messages.map((message, index) => {return <Message key={index} message={message} />})}
    </section>
    }
}

class Message extends React.Component {

    render () {
        return (
            <article className="message-container">
              <label className="message-sender">
                <a href={"/" + this.props.message.sender} >{this.props.message.sender}</a>
              </label>
                &nbsp;&nbsp;
                <small className="message-meta">
                    <time dateTime="this.props.message.created_at">
                    {new Intl.DateTimeFormat("en-GB", {
                        year: "numeric",
                        month: "short",
                        day: "2-digit"
                        }).format( Date.parse(this.props.message.created_at))}
                    </time>
                </small>
                <p className="message-text">{this.props.message.body}</p>
            </article>
        );
    }
}

export default Conversation
